export const URLS = {
  baseURL: "http://localhost:8000/api/",
  news_letter: "news_letter",
};
